import { Box, ListItem, ListItemButton, ListItemText } from "@mui/material";

import { useEffect } from "react";
import { FixedSizeList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";

const renderRow = (props) => {
  const { itemIdProp, setSelectedItem, selectedItem, renderItem } = props;

  const innerRenderRow = (props) => {
    const { index, data, style } = props;

    return (
      <ListItem disablePadding key={data[index][itemIdProp]} style={style}>
        <ListItemButton
          onClick={() => setSelectedItem(data[index])}
          selected={selectedItem[itemIdProp] === data[index][itemIdProp]}
        >
          <ListItemText
            primaryTypographyProps={{ noWrap: true }}
            primary={renderItem(data[index])}
          />
        </ListItemButton>
      </ListItem>
    );
  };

  return innerRenderRow;
};

const ItemSelector = (props) => {
  const { items, selectedItem, setSelectedItem, itemIdProp, renderItem } =
    props;

  useEffect(() => {
    const selectedItemExists = () =>
      items.find((item) => item[itemIdProp] === selectedItem[itemIdProp]);

    if (
      items.length > 0 &&
      selectedItem !== undefined &&
      (!selectedItem[itemIdProp] || !selectedItemExists())
    ) {
      setSelectedItem(items[0]);
    }
  }, [items, selectedItem, setSelectedItem, itemIdProp]);

  return (
    items.length > 0 && (
      <Box
        sx={{
          width: "100%",
          bgcolor: "background.paper",
          display: "flex",
          flexGrow: 1,
          height: "90vh",
        }}
      >
        <AutoSizer>
          {({ height, width }) => (
            <FixedSizeList
              itemSize={48}
              width={width}
              height={height}
              itemData={items}
              overscanCount={5}
              itemCount={items.length}
            >
              {renderRow({
                selectedItem,
                setSelectedItem,
                itemIdProp,
                renderItem,
              })}
            </FixedSizeList>
          )}
        </AutoSizer>
      </Box>
    )
  );
};

export default ItemSelector;
